/**
 * Created by Terence on 2023/2/15 - 21:15
 * Description :
 */
export const OC_RELATION_TYPES = {
  CP: "cp",
  RELATIVE: "relative",
  FRIEND: "friend",
};
